import React from "react";
import BarChartComponent from "./BarChartComponent";
import LineChartComponent from "./LineChartComponent";
import PieChartComponent from "./PieChartComponent";
import BrowserStatsComponent from "./BrowserStatsComponent";
import ProductTableComponent from "./ProductTableComponent";
import "./overviewChart.css";

const OverviewChart = () => {
  return (
    <div className="overview-charts-container">
      {/* Charts Row */}
      <div className="charts-row">
        <BarChartComponent />
        <LineChartComponent />
        <PieChartComponent />
      </div>

      {/* Bottom Row - Browser Stats and Product Table */}
      <div className="bottom-row">
        <BrowserStatsComponent />
        <ProductTableComponent />
      </div>
    </div>
  );
};

export default OverviewChart;
